import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import styled from 'styled-components'
import { Copy, Box, Flex, themeColor } from '@elparking/components'

import messages from './messages'

const PlaceholderNoParkings = styled(Flex)`
    background: ${themeColor('white')};
    text-align: center;
    margin: auto;
    height: 100%;
`

const PlaceholderImgNoParkings = styled.img`
    width: 60%;
    margin-bottom: 6%;
`

class Empty extends React.PureComponent {
    static propTypes = {
        intl: PropTypes.object,
    }

    render () {
        return (
            <PlaceholderNoParkings w='100%' flexDirection='column' alignItems='center' p='2em 1em'>
                <PlaceholderImgNoParkings src='/images/booking-process/illus-no-parking.svg' />
                <Copy padding='0' size='medium'>
                    <Box ml={['0', '12%']} mr={['0', '12%']}>
                        {this.props.intl.formatMessage(messages.notAvailable)}
                    </Box>
                </Copy>
            </PlaceholderNoParkings>
        )
    }
}

export default injectIntl(Empty)
